import { render, staticRenderFns } from "./TaxHistoryChart.vue?vue&type=template&id=86b92b6c&"
import script from "./TaxHistoryChart.vue?vue&type=script&lang=js&"
export * from "./TaxHistoryChart.vue?vue&type=script&lang=js&"
import style0 from "./TaxHistoryChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports